/* eslint-disable @typescript-eslint/no-explicit-any */
const Tipo = ({ setForm, form }: any) => {
  const tipo = [
    {
      name: "Alojamiento completo",
      description:
        "Los huéspedes tienen un alojamiento entero a su disposición",
    },
    {
      name: "Una habitación",
      description:
        "Los huéspedes tienen su propio dormitorio en un  alojamiento, más acceso a espacio comunes compartidos.",
    },
    {
      name: "Una habitación compartida",
      description:
        "Los huéspedes duermen en una habitación o zona común que posiblemente compartan con otras personas.",
    },
  ];

  const onClick = (e: any, value: string) => {
    switch (e.target.name) {
      case "type":
        {
          setForm({
            ...form,
            space: value,
          });
        }
        break;
      default:
        break;
    }
  };
  return (
    <div className="h-[100%] flex justify-center items-center">
      <div className="grid lg:grid-cols-1 gap-10 py-5 px-5">
        <div>
          <span className="font-bold text-black mb-2 block">
            ¿Qué tipo de alojamiento ofrecés a los huéspedes?
          </span>
          <div className="grid grid-cols-1 gap-5">
            {tipo.map((t) => {
              if (t.name == form.space) {
                return (
                  <label className="bg-gray-300 hover:bg-white-700 text-black font-bold py-2 px-4 rounded-2xl shadow cursor-pointer ">
                    <span className="font-bold block">{t.name}</span>
                    <span className="block text-sm">{t.description}</span>
                    <button
                      className="hidden"
                      name="type"
                      onClick={(event) => onClick(event, t.name)}
                    ></button>
                  </label>
                );
              }

              return (
                <label className="bg-white-500 hover:bg-white-700 text-black font-bold py-2 px-4 rounded-2xl shadow cursor-pointer ">
                  <span className="font-bold block">{t.name}</span>
                  <span className="block text-sm">{t.description}</span>
                  <button
                    className="hidden"
                    name="type"
                    onClick={(event) => onClick(event, t.name)}
                  ></button>
                </label>
              );
            })}
          </div>
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Tipo;
